// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderIcon_root__6sobg","content":"PlaceholderIcon_content__ELtPa","textArea":"PlaceholderIcon_textArea__T8N+I","text":"PlaceholderIcon_text__e-cnf"};